import { Attributes, Misc, NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class TransactionInterceptionSearchCriteria extends ValueObject {

    @Rules.Required("Broker is required")
    public staticServiceProviderFileGroupingID: number = 0;

    public rawAccountNumber: string = "";

    public clientAccountNumber: string = "";

    public serviceProviderGroupingName: string | null = null;

    public instrument: string = "";

    public instrumentID: number | null = null;

    public eventName: string = "";

    public eventID: number | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeEndDate: Date | null = null;
}